import CheckIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton, SvgIcon, Tooltip, Typography } from "@mui/material";

type StatusDisplayProps = {
  status: boolean;
  title: string;
  showEdit?: boolean;
  onEdit?: () => void;
  editTooltip?: string;
  children?: React.ReactNode;
};

const StatusDisplay: React.FC<StatusDisplayProps> = (props) => {
  const { status, title, onEdit, showEdit, editTooltip, children } = props;

  return (
    <>
      <Box position="relative">
        <SvgIcon sx={{ fontSize: 80 }} color={status ? "success" : "disabled"}>
          {status ? <CheckIcon /> : <PendingIcon />}
        </SvgIcon>

        {showEdit && (
          <Tooltip arrow title={editTooltip}>
            <IconButton
              edge="start"
              sx={{ position: "absolute", bottom: 0, left: "100%" }}
              onClick={onEdit}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Box>
        <Typography fontWeight="bold">{title}</Typography>
        {children}
      </Box>
    </>
  );
};

export default StatusDisplay;
